import React, { useState } from "react";
import "styles/scss/footer.scss"; 

const Footer = () => {

  const [isOpen, setIsOpen] = useState(false); 
  const toggleDropdown = (event) => {
    event.stopPropagation();
    setIsOpen((prev) => !prev);
  };
  return (
    <footer className="footer">
      <ul className="footer-information container">
        <li className="footer-logo">
            <span className="logo-img"></span>
        </li>
        <li className="footer-InforTxt">
          <div className="inforTxt-2">
            <span>(44921)울산광역시 울주군 범서읍 대리로 89 경동빌딩 2~5층</span>
            <span>전화 : 052-246-1331</span>
            <span>팩스 : 052-246-1991</span>
          </div>
        </li>
        <li className="familySite">
          <div onClick={toggleDropdown} className="familySite-button">FAMILY SITE</div>
          {/* 드롭다운 메뉴 */}
          {isOpen && (
            <ul className={`dropdown-menu ${isOpen ? "open" : "닫힘"}`}>
              <li><a href="http://itnn.kr/" target="_black">아이티엔</a></li>
            </ul>
          )}
        </li>
      </ul>
      <div className="footer-blackBox">
        <p>© Ntek. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
